import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { createElement as u } from "react";
import { c as x } from "./extends-2c39a7b4.js";
import { V as y } from "./Button-ac33fe97.js";
import { C as b, R as H, a as S } from "./getButtonHref-4b514703.js";
import { C as m } from "./ContentRenderer-b6eef314.js";
import { I } from "./Image-ad475371.js";
import "./Parent-2cc4d070.js";
import "./pp-react-theme.esm-ef1d004f.js";
import "./pp-react-icons.esm-6f29efc7.js";
import "./helpers-7c298f27.js";
import "./propsChecker-7de44c11.js";
import "./LazyLoad-41f8370a.js";
const G = ({
  className: c,
  imageUrl: n,
  imageAltText: d,
  headline: r,
  paragraph: l,
  cta: o,
  analyticsCompName: a,
  ...e
}) => {
  const f = x("step-item", c);
  return /* @__PURE__ */ i("div", { className: f, ...e, children: [
    n && /* @__PURE__ */ t(
      I,
      {
        className: "item-image-container",
        alt: d,
        src: n,
        lazyLoad: !0,
        dimensions: {
          minHeight: "150px"
        }
      }
    ),
    /* @__PURE__ */ i("div", { className: "item-text-container", children: [
      /* @__PURE__ */ t(
        m,
        {
          as: "h3",
          className: "item-body-headline",
          analyticsCompName: a,
          analyticsTextSection: "ItemHeadline",
          content: r
        }
      ),
      /* @__PURE__ */ t(
        m,
        {
          as: "p",
          className: "item-body-text",
          analyticsCompName: a,
          analyticsTextSection: "ItemParagraph",
          content: l
        }
      ),
      o && (({ url: p, mobileUrl: h, ...g }, N) => {
        const C = {
          analyticsCompName: a,
          className: N,
          // These fields are named 'href' instead
          href: p,
          mobileHref: h,
          ...g
        };
        return /* @__PURE__ */ t(y, { ...C });
      })(o, "item-body-cta")
    ] })
  ] });
}, P = ({
  className: c,
  headline: n,
  paragraph: d,
  cta: r,
  collection: l = [],
  ...o
}) => {
  const a = x("getting-started", c), e = "GettingStartedSteps";
  return /* @__PURE__ */ t("section", { className: a, ...o, children: /* @__PURE__ */ t(b, { children: /* @__PURE__ */ i(H, { className: "getting-started-row", children: [
    /* @__PURE__ */ i(S, { sm: 12, md: 4, className: "heading-col", children: [
      /* @__PURE__ */ t(
        m,
        {
          as: "h2",
          className: "heading",
          analyticsCompName: e,
          analyticsTextSection: "Headline",
          content: n
        }
      ),
      /* @__PURE__ */ t(
        m,
        {
          as: "p",
          className: "hatch-text",
          analyticsCompName: e,
          content: d
        }
      ),
      r && (({ url: s, mobileUrl: p, ...h }, g) => {
        const N = {
          componentName: e,
          className: g,
          // These fields are named 'href' instead
          href: s,
          mobileHref: p,
          ...h
        };
        return /* @__PURE__ */ t(y, { ...N });
      })(r, "getting-started-cta")
    ] }),
    /* @__PURE__ */ t(S, { sm: 12, md: 8, children: l.map((s) => /* @__PURE__ */ u(
      G,
      {
        ...s,
        key: s.headline,
        analyticsCompName: e
      }
    )) })
  ] }) }) });
};
P.displayName = "GettingStartedSteps";
export {
  P as default
};
//# sourceMappingURL=GettingStartedSteps.js.map
